/**
 * Shown while a route's chunk (and any loader) is still resolving. Route components own their
 * own `<AppLayout>`, so this renders bare — it replaces the page, not the shell. Kept dependency-free
 * on purpose: it lives in the entry chunk, so anything imported here is paid for on first paint.
 */
export const RoutePending = () => (
  <div className="flex min-h-dvh w-full items-center justify-center" role="status" aria-label="Loading page">
    <div className="h-6 w-6 animate-spin rounded-full border-2 border-muted-foreground/30 border-t-primary" />
  </div>
)
